<div class="gallery-dialog__box" [style.width.px]="width">
  <swiper [config]="config" (slideChange)="onSlideChange($event)" #swiper (swiper)="onSwiper($event)">
    <ng-container *ngFor="let item of data.items; let i = index">
      <ng-template swiperSlide>
        <ng-container [ngSwitch]="item.type" *ngIf="activeIndex === i || activeIndex === i + 1  || activeIndex === i - 1">
          <ng-template [ngSwitchCase]="MediaType.Image">
            <app-gallery-image [image]="item" [index]="i" (handleSlideEvent)="slideEventListener($event)"></app-gallery-image>
          </ng-template>
          <ng-template [ngSwitchCase]="MediaType.Video">
            <app-gallery-video [video]="item" [play]="activeIndex === i" [index]="i" (handleSlideEvent)="slideEventListener($event)"></app-gallery-video>
          </ng-template>
          <ng-template [ngSwitchCase]="MediaType.Panorama">
            <app-gallery-panorama [panorama]="item" [index]="i" (handleSlideEvent)="slideEventListener($event)"></app-gallery-panorama>
          </ng-template>
        </ng-container>
      </ng-template>
    </ng-container>
  </swiper>

  <ng-container *ngIf="data.items.length > 1">
    <button class="gallery-dialog__button gallery-dialog__button-prev" [class.gallery-dialog__button-show]="activeIndex !== 0">
    </button>
    <button class="gallery-dialog__button gallery-dialog__button-next" [class.gallery-dialog__button-show]="activeIndex + 1 !== data.items.length ">
    </button>
  </ng-container>

  <div *ngIf="data.items.length" class="gallery-dialog__info">
    Image {{activeIndex + 1}} of {{data.items.length}}
  </div>

  <div class="gallery-dialog__close" (click)="dialogRef.close()">
    <img src="/assets/images/product/close.png" alt="close" />
  </div>
</div>